import './style.scss'
import React, { useEffect, useRef, useState } from 'react'
import { FiFilter, FiChevronDown } from 'react-icons/fi'
import { Box, Text, tokens } from 'src/componentv2/Base/ui'

export interface FilterOption {
    label: string
    value: string
}

export interface FilterDropdownProps {
    options: FilterOption[]
    value: string[]
    onChange: (value: string[]) => void
    label?: string
    width?: string
    className?: string
    footer?: React.ReactNode
}

export const FilterDropdown: React.FC<FilterDropdownProps> = ({
                                                                  options,
                                                                  value,
                                                                  onChange,
                                                                  label = 'Filters',
                                                                  width = '20rem',
                                                                  className = '',
                                                                  footer,
                                                              }) => {
    const [open, setOpen] = useState(false)
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!open) return
        const onClickOutside = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
        }
        document.addEventListener('mousedown', onClickOutside)
        return () => document.removeEventListener('mousedown', onClickOutside)
    }, [open])

    const toggleValue = (val: string) => {
        onChange(value.includes(val) ? value.filter((v) => v !== val) : [...value, val])
    }

    const groups: FilterOption[][] = []
    let lastCategory: string | null = null
    options.forEach((option) => {
        const category = option.value.split(':')[0]
        if (category !== lastCategory) {
            groups.push([])
            lastCategory = category
        }
        groups[groups.length - 1].push(option)
    })

    return (
        <div className={`filter-dropdown ${className}`} ref={ref} style={{ width }}>
            <button
                type="button"
                className={`filter-dropdown__trigger ${value.length ? 'filter-dropdown__trigger--active' : ''}`}
                onClick={() => setOpen((v) => !v)}
            >
                <FiFilter size={16} />
                <Text fontSize="1.4" fontWeight="500" color="inherit">{label}</Text>
                {value.length > 0 && <span className="filter-dropdown__count">{value.length}</span>}
                <FiChevronDown
                    size={14}
                    className={`filter-dropdown__chevron ${open ? 'filter-dropdown__chevron--open' : ''}`}
                />
            </button>

            {open && (
                <Box className="filter-dropdown__panel" bgColor={tokens.white} shadow={tokens.shadowPopup} radius="1.2">
                    <div className="filter-dropdown__options">
                        {groups.map((group, i) => (
                            <div key={i} className="filter-dropdown__group">
                                {group.map((option) => (
                                    <label key={option.value} className="filter-dropdown__option">
                                        <span className="filter-dropdown__checkbox">
                                            <input
                                                type="checkbox"
                                                checked={value.includes(option.value)}
                                                onChange={() => toggleValue(option.value)}
                                            />
                                            <span className="filter-dropdown__checkbox-box" />
                                        </span>
                                        <Text fontSize="1.4">{option.label}</Text>
                                    </label>
                                ))}
                            </div>
                        ))}
                    </div>

                    {footer && (
                        <div className="filter-dropdown__footer">
                            {footer}
                        </div>
                    )}
                </Box>
            )}
        </div>
    )
}

export default FilterDropdown